import React, { useEffect } from 'react';
import CandlestickChart from '../Chart';
import ChartTypeSelector from '../Chart/ChartTypeSelector';
import IndicatorSelector from '../Chart/IndicatorSelector';
import ShortcutReference from './ShortcutReference';

const ChartSection = ({
  selectedCoin,
  timeframe,
  setTimeframe,
  setLivePrice,
  activeHolding,
  orders,
  chartType,
  setChartType,
  showVolume,
  setShowVolume,
  activeIndicators,
  handleToggleIndicator,
  handleClearIndicators,
}) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Ignore shortcuts if the user is typing in an input field
      if (['INPUT', 'TEXTAREA'].includes(e.target.tagName)) return;

      // Timeframe Shortcuts (Alt + Number)
      if (e.altKey) {
        switch (e.key) {
          case '1': e.preventDefault(); setTimeframe('1m'); break; // Alt + 1: 1m
          case '2': e.preventDefault(); setTimeframe('5m'); break; // Alt + 2: 5m
          case '3': e.preventDefault(); setTimeframe('15m'); break; // Alt + 3: 15m
          case '4': e.preventDefault(); setTimeframe('30m'); break; // Alt + 4: 30m
          case '5': e.preventDefault(); setTimeframe('1h'); break; // Alt + 5: 1h
          case '6': e.preventDefault(); setTimeframe('4h'); break; // Alt + 6: 4h
          case '7': e.preventDefault(); setTimeframe('1d'); break; // Alt + 7: 1d
          default: break;
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [setTimeframe]);

  return (
    <section className="chart-section-container">
      <div className="chart-toolbar">
        {/* TimeFrame Selector */}
        <div className="timeframe-selector">
          {['1m', '5m', '15m', '30m', '1h', '4h', '1d'].map((tf) => (
            <button 
              key={tf} 
              className={`tf-btn ${timeframe === tf ? 'active-tf' : ''}`}
              onClick={() => setTimeframe(tf)}
            >
              {tf}
            </button>
          ))}
        </div>
        <div className="chart-toolbar-separators" style={{ width: '1px', height: '24px', backgroundColor: 'var(--border-color)', margin: '0 8px' }}></div>
        <ChartTypeSelector chartType={chartType} onChange={setChartType} />
        <div className="chart-toolbar-separators" style={{ width: '1px', height: '24px', backgroundColor: 'var(--border-color)', margin: '0 8px' }}></div>
        <IndicatorSelector
          activeIndicators={activeIndicators}
          onToggle={handleToggleIndicator}
          onClear={handleClearIndicators}
          showVolume={showVolume}
          onToggleVolume={() => setShowVolume(v => !v)}
        />
        <div className="chart-toolbar-separators" style={{ width: '1px', height: '24px', backgroundColor: 'var(--border-color)', margin: '0 8px' }}></div>
        <ShortcutReference />
        
        <div className="chart-title" style={{ marginLeft: 'auto' }}>
          {selectedCoin ? `${selectedCoin.name} (${selectedCoin.symbol.toUpperCase()}/USDT)` : 'Loading chart...'}
        </div>
      </div>
      
      <div className="chart-wrapper">
        {selectedCoin && (
          <CandlestickChart
            coin={selectedCoin}
            timeframe={timeframe}
            onPriceUpdate={setLivePrice}
            stopLoss={activeHolding?.stopLoss}
            takeProfit={activeHolding?.takeProfit}
            activeLimitOrders={orders}
            chartType={chartType}
            onChartTypeChange={setChartType}
            showVolume={showVolume}
            onToggleVolume={() => setShowVolume(v => !v)}
            activeIndicators={activeIndicators}
            onToggleIndicator={handleToggleIndicator}
            onClearIndicators={handleClearIndicators}
            trades={orders.filter(o => o.status === 'FILLED')}
          />
        )}
      </div>
    </section>
  );
};

export default ChartSection;
